module.exports = __webpack_public_path__ + "img/hungarynew.27c88674.jpg";